import { Box } from "@mui/material";
import img1 from "../../../../../assets/images/home/gallery/img1.png";
import img2 from "../../../../../assets/images/home/gallery/img2.png";
import img3 from "../../../../../assets/images/home/gallery/img3.png";
import img4 from "../../../../../assets/images/home/gallery/img4.png";
import img5 from "../../../../../assets/images/home/gallery/img5.png";
import img6 from "../../../../../assets/images/home/gallery/img6.png";
import img7 from "../../../../../assets/images/home/gallery/img7.png";
import img8 from "../../../../../assets/images/home/gallery/img8.png";
import img9 from "../../../../../assets/images/home/gallery/img9.png";

export const Gallery = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: 2,
        px: 2,
        height: "calc(100% - 22px)",
        aspectRatio: { xs: 1.08, md: "auto" },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 2, width: "33%" }}
      >
        <Box sx={{ position: "relative", height: "40%", flexShrink: 0 }}>
          <img
            src={img7}
            alt="img7"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
        <Box sx={{ position: "relative", height: "30%", flexShrink: 0 }}>
          <img
            src={img8}
            alt="img8"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
        <Box
          sx={{
            position: "relative",
            height: "40%",
            flexShrink: 0,
          }}
        >
          <img
            src={img9}
            alt="img9"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 2, width: "33%" }}
      >
        <Box sx={{ position: "relative", height: "30%", flexShrink: 0 }}>
          <img
            src={img6}
            alt="img6"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
        <Box sx={{ position: "relative", height: "50%", flexShrink: 0 }}>
          <img
            src={img5}
            alt="img5"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
        <Box
          sx={{
            position: "relative",
            height: "40%",
            flexShrink: 0,
          }}
        >
          <img
            src={img4}
            alt="img4"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 2, width: "33%" }}
      >
        <Box sx={{ position: "relative", height: "40%", flexShrink: 0 }}>
          <img
            src={img3}
            alt="img3"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
        <Box sx={{ position: "relative", height: "30%", flexShrink: 0 }}>
          <img
            src={img2}
            alt="img2"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
        <Box
          sx={{
            position: "relative",
            height: "40%",
            flexShrink: 0,
          }}
        >
          <img
            src={img1}
            alt="img1"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
